import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Linear} from 'gsap';
import gsap from 'gsap-react-plugin';
import * as enviromentHelper from '../../../helpers/environmentHelper';

class AccordionContent extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            className: "",
            locale: {},
            renderedScreen: {},
            animating: false,
            hasBeenViewed: false,
            render: false
        };
        this.setRenderedScreen = this.setRenderedScreen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.objectIsEnabled = this.objectIsEnabled.bind(this);
        this.objectIsComplete = this.objectIsComplete.bind(this);
        this.openCloseItem = this.openCloseItem.bind(this);
        this.onAnimationComplete = this.onAnimationComplete.bind(this);
        this.onAnimationOpenComplete = this.onAnimationOpenComplete.bind(this);
        this.setItemViewed = this.setItemViewed.bind(this);
        this.allowRender = this.allowRender.bind(this);
    }

    componentDidMount() {
        this.setRenderedScreen();
        window.addEventListener("resize", this.openCloseItem);
    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {
        if (this.props.toggleAllItems) {
            this.openCloseItem();
        }
        let item = this.refs[`accordion_content_${this.props.screen.screen_id}`];
        if (item.classList.contains('active') && !this.state.hasBeenViewed) {
            this.setItemViewed();
        }
        if(this.props.screen.screen_id === this.props.activeScreenId || this.props.activeScreenId === "0") {
            this.props.biteCallbacks.setIsAnimating(this.state.animating);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.openCloseItem);
    }

    openCloseItem() {
        let env = enviromentHelper.getEnvironment();
        let item = this.refs[`accordion_content_${this.props.screen.screen_id}`];
        let btn = document.getElementById(`accordion_btn_${this.props.screen.screen_id}`);
        if(appHelper.isDefined(item)){
            //console.log(`${this.props.screen.screen_id} !== ${this.props.activeScreenId} && ${!this.state.animating}`);
            if (this.props.screen.screen_id !== this.props.activeScreenId && !this.state.animating) {
                this.setState({animating: true});
                TweenLite.to(item, 0.5, {
                    height: 0,
                    ease: Linear.easeIn
                }).eventCallback("onComplete", this.onAnimationComplete);
            } else if (this.props.screen.screen_id === this.props.activeScreenId && !this.state.animating) {
                let value = (btn.offsetHeight * 3) + 80;
                if(env.window.size === "xs"){
                    value = btn.offsetHeight * 2 + 108;
                }
                /*if(this.props.parentScreen.include_icon){
                    value = 180;
                }*/
                let height = document.getElementById('main-wrapper').clientHeight - value;
                this.setState({animating: true});

                TweenLite.to(item, 0.5, {
                    height: height,
                    ease: Linear.easeIn
                }).eventCallback("onComplete", this.onAnimationOpenComplete);
            }
        }
        /*if (this.props.screen.screen_id !== this.props.activeScreenId && !this.state.animating) {
            this.setState({animating: true});
            TweenLite.to(item, 0.5, {
                height: 0,
                ease: Linear.easeIn
            }).eventCallback("onComplete", this.onAnimationComplete);
        } else if (this.props.screen.screen_id === this.props.activeScreenId && !this.state.animating) {
            this.setState({animating: true});
            TweenLite.set(item, {height: "auto"});
            TweenLite.from(item, 0.5, {
                height: 0,
                ease: Linear.easeIn
            }).eventCallback("onComplete", this.onAnimationComplete);
        }*/
    }

    onAnimationOpenComplete(){
        this.props.biteCallbacks.onItemsClosed();
        this.props.setScrollPosition();
        this.setState({animating: false});
    }

    onAnimationComplete() {
        this.props.biteCallbacks.onItemsClosed();
        this.props.setScrollPosition();
        this.setState({animating: false});
    }
    allowRender(){
        this.setState({render:true});
    }
    setRenderedScreen() {
        let screenType = Object.assign({}, getScreenComponentByType(this.props.screen.screen_type),
            {
                data: this.props.screen
            }
        );

        this.setState({renderedScreen: Object.assign({}, screenType)});
    }


    objectIsEnabled() {
        return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.props.screen.screen_id);
    }

    objectIsComplete() {
        return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.props.screen.screen_id);
    }


    setClass() {
        let className = "";
        if (this.props.screen.screen_id === this.props.activeScreenId) {
            className += "active ";
        }

        if (this.objectIsEnabled() === -1) {
            className += "disabled ";
        }

        if (this.objectIsComplete() > -1) {
            className += "complete ";
        } else {
            className += "incomplete ";
        }

        return className;
    }


    setItemViewed() {
        this.setState({hasBeenViewed: true});

    }

    render() {
        let renderedScreen = this.state.renderedScreen;
        return (
            <div className={`accordion-content ${this.setClass()}`} ref={`accordion_content_${this.props.screen.screen_id}`}>
                <div className="content-padding">
                    {typeof renderedScreen.data !== "undefined" && this.state.hasBeenViewed
                        ?
                        <renderedScreen.component screen={renderedScreen.data}
                                                  parentScreen={this.props.parentScreen}
                                                  biteCallbacks={this.props.biteCallbacks}/>
                        : null
                    }
                </div>
            </div>
        );

    }
}

AccordionContent.propTypes = {
    parentScreen: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    activeScreenId: PropTypes.number.isRequired,
    enabledScreens: PropTypes.array.isRequired,
    completeScreens: PropTypes.array.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    toggleAllItems: PropTypes.bool.isRequired,
    setScrollPosition: PropTypes.func.isRequired,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    actions: PropTypes.object
};

AccordionContent.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccordionContent);



/** WEBPACK FOOTER **
 ** ./src/components/screens/accordionScreen/AccordionContent.js
 **/